import React from 'react';

interface DashboardHeaderItemProps {
  iconSrc: string;
  title: string;
  value: number;
  id?: string;
  action?: (id: any) => void;
  activeClass?: boolean;
}

const DashboardHeaderItem: React.FC<DashboardHeaderItemProps> = ({
  iconSrc,
  title,
  value,
  id,
  action,
  activeClass,
}) => {
  const handleMenuClick = () => {
    if (action && id) {
      action(id);
    }
  };

  return (
    <button
      onClick={handleMenuClick}
      className={
        activeClass
          ? 'dashboard_header-contant dashboard_header-contan-active'
          : 'dashboard_header-contant'
      }
    >
      <img src={iconSrc} alt={`${title} img`} />
      <div>
        <h5>{title}</h5>
        <h4>{value}</h4>
      </div>
    </button>
  );
};

const MemoizedComponent = React.memo(DashboardHeaderItem);
export default MemoizedComponent;
